/**
 *  BLOCK: Cloudbeds
 *  ---
 *  Add Cloudbeds Booking Engine iFrame to a Page
 */

const { __ } = wp.i18n
const { registerBlockType } = wp.blocks;

import EditBlock from "./EditBlock.js"

const myallocatorSVG = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                        <path fill="#dca50a" d="M0 0h64v64H0z"/>
                        <g fill="#fff">
                          <path d="M0 20.5C0 31.8.2 41 .5 41c.2 0 1.4-.5 2.7-1 2.2-1 2.3-1.6 2.3-10.8 
                          0-8.6.3-10.3 2.7-14.8 3-5.8 7.3-9.8 13.3-12.5l4-1.9H0v20.5z"/>
                          <path d="M43.8 2c4.4 2 4.9 3.1 3.2 7.5-.8 2.2-1.5 2.6-3.3 2-7.4-2.2-10.1-2.5-13.4-1.4-6.2 2-10.5 
                          11.8-8.9 20.3.6 3.4.8 3.4 3.7 2.4 1.6-.6 3.2-.8 3.5-.5 1.1 1.1-7.1 18.6-9.1 19.5-1.6.8-3.7 
                          0-10.3-3.9C4.7 45.2.7 43 .5 43 .2 43 0 47.7 0 53.5V64l15.3-.1c8.3-.1 14.4-.3 13.5-.6-2.4-.6-2.3-1.4.7-7.3 
                          3-6 4.7-7.1 9-5.7C48.2 53.2 56 45.5 56 33.1c0-5.4-1-7.4-3.3-6.5-2 .7-2 .8-.6-7.3.6-3.5 1.6-6.3 2.2-6.3s3.1 
                          1.9 5.4 4.2l4.3 4.2V0H39.5l4.3 2z"/>
                          <path d="M62.7 23.7c-.3.5-.1 1.7.4 2.8.7 1.7.8 1.7.8-.8.1-2.7-.4-3.4-1.2-2zM63 43.6c0 .9-1.2 3.8-2.7 
                          6.5-2.6 4.8-6.7 8.8-12.7 12.1-3.1 1.7-3.1 1.7 6.7 1.8H64V53c0-6.1-.2-11-.5-11s-.5.7-.5 1.6z"/>
                        </g>
                      </svg>

registerBlockType('bed66-blocks/myallocator', {

    title: 'MyAllocator',
  
    icon: myallocatorSVG,
  
    category: 'bed66',
  
    attributes: {
      defaultURL: {
        type: 'string',
        default: 'https://theme.zdassets.com/theme_assets/712989/01ffa4a42fcc875a029c8ae02e67e44c3d1d751b.png'
      },
      tempURL: {
        type: 'string',
        default: 'https://theme.zdassets.com/theme_assets/712989/01ffa4a42fcc875a029c8ae02e67e44c3d1d751b.png'
      },
      url: {
        type: 'string',
        default: ''
      },
      widgetParam: {
        type: 'string',
        default: '?widget=1',
      },
      widthField: {
        type: 'string',
        default: '100%',
      },
      heightField: {
        type: 'string',
        default: '500px',
      },
      borderField: {
        type: 'string',
        default: '0'
      },
      scrollField: {
        type: 'string',
        default: 'no'
      },
      classField: {
        type: 'string',
        default: 'iframe-class'
      },
    },
  
    edit: EditBlock,
  
    save( { attributes } ) {
      const { url, widgetParam, widthField, heightField, borderField, scrollField, classField } = attributes;
  
      return (
        <div>
        <iframe src={url + widgetParam} width={widthField} height={heightField} frameborder={borderField} scrolling={scrollField} class={classField} id="bed66_iFrame"></iframe>
        <script type="text/javascript" src="https://hotels.cloudbeds.com/widget/iFrameResizer"></script><script>window.iFrameResize({"{}"}, '#bed66_iFrame')</script>
        </div>
        );
    },

  });